import { useEffect } from "react";

const ensureMetaTag = (selector, attributes = {}) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) => {
      tag.setAttribute(key, value);
    });
    document.head.appendChild(tag);
  }
  return tag;
};

const ensureLinkTag = (selector, attributes = {}) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("link");
    Object.entries(attributes).forEach(([key, value]) => {
      tag.setAttribute(key, value);
    });
    document.head.appendChild(tag);
  }
  return tag;
};

const upsertStructuredData = (structuredData) => {
  const scriptId = "seo-structured-data";
  const existing = document.getElementById(scriptId);

  if (!structuredData) {
    if (existing) {
      existing.remove();
    }
    return;
  }

  const script = existing || document.createElement("script");
  script.id = scriptId;
  script.type = "application/ld+json";
  script.text = JSON.stringify(structuredData);

  if (!existing) {
    document.head.appendChild(script);
  }
};

const useSEO = ({
  title,
  description,
  keywords,
  canonicalPath,
  openGraphImage,
  structuredData,
}) => {
  useEffect(() => {
    const siteName = "VIVID H2O Solutions";
    const finalTitle = title ? `${title} | ${siteName}` : siteName;
    document.title = finalTitle;

    if (description) {
      const descriptionTag = ensureMetaTag('meta[name="description"]', {
        name: "description",
      });
      descriptionTag.setAttribute("content", description);
    }

    if (keywords) {
      const keywordsTag = ensureMetaTag('meta[name="keywords"]', {
        name: "keywords",
      });
      keywordsTag.setAttribute("content", keywords);
    }

    const ogTitle = ensureMetaTag('meta[property="og:title"]', {
      property: "og:title",
    });
    ogTitle.setAttribute("content", finalTitle);

    const ogDescription = ensureMetaTag('meta[property="og:description"]', {
      property: "og:description",
    });
    ogDescription.setAttribute("content", description || "Industrial water treatment insights and solutions.");

    const ogType = ensureMetaTag('meta[property="og:type"]', {
      property: "og:type",
    });
    ogType.setAttribute("content", "website");

    if (openGraphImage) {
      const ogImage = ensureMetaTag('meta[property="og:image"]', {
        property: "og:image",
      });
      ogImage.setAttribute("content", openGraphImage);
    }

    const canonicalHref = canonicalPath
      ? `${window.location.origin}${canonicalPath}`
      : window.location.href;
    const canonicalTag = ensureLinkTag('link[rel="canonical"]', {
      rel: "canonical",
    });
    canonicalTag.setAttribute("href", canonicalHref);

    upsertStructuredData(structuredData);
  }, [
    title,
    description,
    keywords,
    canonicalPath,
    openGraphImage,
    structuredData,
  ]);
};

export default useSEO;
